import 'focus-visible'
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import Vue from 'vue'


import VueMq from 'vue-mq'
import { mapState } from 'vuex'
const cssVars = require('../styles/base/_vars.scss'); 
import components from './vue-components'
import { money, moneyWithoutDecimals, moneyWithoutTrailingZeros } from './filters/money.js'
import store from './store'

Vue.use(VueMq, {
  breakpoints: {
    mobile: parseInt(cssVars.breakTablet, 10),
    tablet: parseInt(cssVars.breakDesktop, 10),
    desktop: parseInt(cssVars.breakHd, 10),
    hd: Infinity
  }
})


Vue.filter('money', money) 

window.vueApp = new Vue({
  store,
  components,
  comments: true,
  computed: {
    ...mapState({
      checkout: state => state.cart.checkout
    }),
    featuredProductSlidesToShow () {
      if (this.$mq === 'mobile') return 1.8
      if (this.$mq === 'tablet') return 3
      return 4
    }
  },
  created () {
    this.$store.dispatch('cart/init')
    this.$store.dispatch('products/init')
    this.$store.dispatch('scroll/init')
  },
  mounted () {
    // on mount, start listening for load events
    // on a section load, re-mount section to reflect admin changes

    document.addEventListener('shopify:section:load', (event) => {
      const sectionContainer = document.getElementById(event.target.id);
      const NewComponent = Vue.extend({
        components,
        template: event.target.innerHTML,
      });
      const component = new NewComponent({ store }).$mount();

      sectionContainer.innerHTML = '';
      sectionContainer.appendChild(component.$el);
      window.dispatchEvent(new Event('resize'))
    });
  }
}).$mount('#app')

Vue.config.devtools = true;